









































































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { LineEditorForm } from "../forms/LineEdtiorForms";
import { Shop } from "../../shop/models/Shop";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => LineEditorForm
    },
    shops: {
      type: Array as () => Shop[]
    },
    validations: {
      type: Object
    },
    state: {
      type: String
    }
  },
  computed: {
    ...proxyModel(
      "shop",
      "shopName",
      "lineKey",
      "mcApiKey",
      "mcSecretkey",
      "autoApprove"
    ),
    isUpdateState() {
      return (this as any).state === "UPDATE";
    },
    shopError() {
      return (this as any).validations.shop.$error
        ? "shop is required or invalid"
        : "";
    },
    shopNameError() {
      return (this as any).validations.shopName.$error
        ? "shopName is required or invalid"
        : "";
    },
    lineKeyError() {
      return (this as any).validations.lineKey.$error
        ? "lineKey is required or invalid"
        : "";
    },
    mcApiKeyError() {
      return (this as any).validations.mcApiKey.$error
        ? "MC API Key is required or invalid"
        : "";
    },
    mcSecretkeyError() {
      return (this as any).validations.mcSecretkey.$error
        ? "MC Secret Key is required or invalid"
        : "";
    }
  }
});
